<template>
  <div class="calendar-table-view">
    <HubEventsTable
      :name="'past-events'"
      :title="past.title"
      :items="past.items"
      :buttonCaption="$t('message.common.buttons.morePastEvents')"
      v-if="hasPastItems"
    />
    <HubEventsTable
      :name="'upcoming-events'"
      :title="upcoming.title"
      :items="upcoming.items"
      :buttonCaption="$t('message.common.buttons.moreUpcomingEvents')"
      v-if="hasUpcomingItems"
    />
    <CalendarLegend
      :items="legendItems"
      :title="$t(`message.calendar.legend`)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import updateBreadcrumb from '@mixins/updateBreadcrumb'
import HubEventsTable from '@blocks/hubs/HubEventsTable'
import CalendarLegend from '@blocks/calendar/CalendarLegend'
import legendItems from '@mixins/legendItems'

export default {
  name: 'CalendarTableView',
  mixins: [ updateBreadcrumb, legendItems ],
  components: {
    HubEventsTable,
    CalendarLegend
  },
  computed: {
    ...mapGetters({
      past: 'events/getPast',
      upcoming: 'events/getUpcoming'
    }),
    hasPastItems () {
      return this.past.items.length
    },
    hasUpcomingItems () {
      return this.upcoming.items.length
    }
  }
}
</script>
<style lang="scss">
  .calendar-table-view {
    .hub-events-table {
      margin-bottom: 4rem;
    }
  }
</style>
